// utils/colorOptions.js

// Predefined color palette
export const colorOptions = [
    '#111111', // Black
    '#212529', // Dark Gray
    '#444444', // Medium Gray
    '#BBBBBB', // Grey
    '#F0F0F0', // Chalk
    '#5c0812', // Wine Red
    '#af1726', // Red
    '#9f5389', // Salmon
    '#FD7E14', // Orange
    '#FFC107', // Yellow
    '#46a31e', // Light Green
    '#166831', // Medium Green
    '#05441a', // Green
    '#08ccff', // Cyan
    '#0d9da6', // Teal
    '#164469', // Ocean
    '#0D6EFD', // LightBlue
    '#0b459b', // Dark Blue
    '#140da6', // Indigo
    '#9c0b8d', // Pink
    '#490ea7', // Purple
    '#280660', // Dark Purple
    '#111827', // bg-gray-900
  ];
  